module.exports = __webpack_public_path__ + "static/media/deal-advisory.c59fbc64.webp";